<template>
  <div v-if="originLoginType === 'assur_cc'">
    <AssurCC
      :mechanicName="drivingSchoolName"
      :mechanicGarage="mechanicGarage"
      :mechanicCode="mechanicCode"
    />
  </div>
  <div v-else-if="originLoginType === 'garanties_mechanics'">
    <GarantiesMechanic
      :mechanicName="drivingSchoolName"
      :mechanicGarage="mechanicGarage"
      :mechanicCode="mechanicCode"
    />
  </div>
  <div v-else-if="originLoginType === 'dynassurances'">
    <Dynassurances
      :mechanicName="drivingSchoolName"
      :mechanicGarage="mechanicGarage"
      :mechanicCode="mechanicCode"
    />
  </div>
  <div v-else>
    <div class="header">
        <div class="container-fluid">
            <div class="header__content">
                <div class="header__content__logo">
                    <a :href="dynassurancesUrl" class="logo__image">
                        <img src="../../assets/logo.gif"
                             alt="Dynassurances : L'assurance d'&ecirc;tre bien assur&eacute;"
                             width="286" height="105"
                             title="Dynassurances : L'assurance d'&ecirc;tre bien assur&eacute;"/>
                    </a>
                </div>
                <div class="header__greetings">{{greetings}}</div>
                <div class="header__content__account">
                    <a href="" class="dropdown-toggle"
                       id="headerDropDown"
                       data-toggle="dropdown"
                       aria-haspopup="true"
                       aria-expanded="false">
                        <div class="header__content__account__avatar">
                            <img src="../../assets/avatar-default-white.png" alt="">
                        </div>
                        <div class="header__content__account__avatar--name">{{ drivingSchoolName }}</div>
                    </a>
                    <div class="header__content__account__name">
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="headerDropDown">
                            <router-link class="dropdown-item" to="/double_commande/mon-compte">
                                <span>Mon compte</span>
                            </router-link>
                            <a href="#" class="dropdown-item" @click="$root.logOut">
                                <span>Deconnexion</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

    import AssurCC from "@/components/Headers/AssurCC";
    import GarantiesMechanic from "@/components/Headers/GarantiesMechanic";
    import Dynassurances from "@/components/Headers/Dynassurances";
    const GLOBAL_URL = 'http://dynassurances.fr/';

    export default {
        name: 'DrivingSchoolHeader',
        components: {Dynassurances, GarantiesMechanic, AssurCC},
        data() {
            return {
                home_page: GLOBAL_URL
            }
        },
        computed: {
            drivingSchoolName() {
                let drivingSchool = this.$store.state.userInfo.driving_school;
                return drivingSchool ? drivingSchool.name : '';
            },
            greetings() {
                let drivingSchool = this.$store.state.userInfo.driving_school;
                return drivingSchool ? `Bienvenue ${drivingSchool.name}` : '';
            },
            dynassurancesUrl() {
                return this.$store.state.dynassurances_web_site_url
            },
            mechanicGarage() {
              let garage = (this.$store.state.userInfo && this.$store.state.userInfo.driving_school) ? `${this.$store.state.userInfo.driving_school.name}` : null;
              return garage ? garage : '';
            },
            mechanicCode() {
              let code = (this.$store.state.userInfo && this.$store.state.userInfo.driving_school) ? this.$store.state.userInfo.driving_school.individual_axa_number : null;
              return code ? code : '';
            },
            originLoginType() {
              return this.$store.state.userInfo.origin_login || 'dynassurances';
            },
        },
        methods: {},
        mounted() {}
    }
</script>



// WEBPACK FOOTER //
// src/components/DrivingSchool/DrivingSchoolHeader.vue